import React, { FunctionComponent } from "react";

import styles from "./MenuList.module.scss";

export const MenuListDivider: FunctionComponent = () => <li className={styles.menuListDivider} />;
